export default __webpack_public_path__ + "static/media/chi-comic.06d37ddb.jpg";